// Sidebar pour page produit
class ProductSidebar {
  constructor() {
    this.sidebar = null;
    this.overlay = null;
    this.init();
  }

  init() {
    console.log('ProductSidebar: Initialisation', 'Template détecté:', document.body.className);
    // Créer la sidebar seulement sur les pages produit
    if (document.body.classList.contains('template-product')) {
      console.log('ProductSidebar: Page produit détectée - création sidebar');
      this.createSidebar();
      this.bindEvents();
    } else {
      console.log('ProductSidebar: Pas une page produit - pas de sidebar');
    }
  }

  createSidebar() {
    // Créer l'overlay
    this.overlay = document.createElement('div');
    this.overlay.className = 'product-sidebar-overlay';
    
    // Créer la sidebar
    this.sidebar = document.createElement('div');
    this.sidebar.className = 'product-sidebar';
    
    // Ajouter au DOM d'abord
    document.body.appendChild(this.overlay);
    document.body.appendChild(this.sidebar);
    
    // Puis charger le contenu avec les données produit par défaut
    this.loadProductData();
  }

  loadProductData() {
    if (!this.sidebar) return;
    
    // Récupérer les données produit depuis la page
    const productData = this.getProductMetafields();
    
    // Récupérer les traductions depuis les attributs data-
    const labelDiameter = document.documentElement.getAttribute('data-dimension-diameter') || 'Diameter:';
    const labelHeight = document.documentElement.getAttribute('data-dimension-height') || 'Height:';
    const labelWidth = document.documentElement.getAttribute('data-dimension-width') || 'Width:';
    const labelLength = document.documentElement.getAttribute('data-dimension-length') || 'Length:';
    
    this.sidebar.innerHTML = `
      <div class="product-sidebar__header">
      <h3>Détails</h3>
      <button class="product-sidebar__close" aria-label="Fermer">
        <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.575736 4.57574C0.341421 4.81005 0.341421 5.18995 0.575736 5.42426L4.39411 9.24264C4.62843 9.47696 5.00833 9.47696 5.24264 9.24264C5.47696 9.00833 5.47696 8.62843 5.24264 8.39411L1.84853 5L5.24264 1.60589C5.47696 1.37157 5.47696 0.991674 5.24264 0.757359C5.00833 0.523045 4.62843 0.523045 4.39411 0.757359L0.575736 4.57574ZM19 5V4.4L1 4.4V5V5.6L19 5.6V5Z" fill="#0A0A0A"/>
        </svg>
      </button>
      </div>
      <div class="product-sidebar__content">
      <div class="product-sidebar__description">
      </div>
      <div class="product-sidebar__details">
        ${productData.diameter && productData.diameter !== 'N/A' ? `<p><strong>${labelDiameter}</strong> ${productData.diameter}</p>` : ''}
        ${productData.height && productData.height !== 'N/A' ? `<p><strong>${labelHeight}</strong> ${productData.height}</p>` : ''}
        ${productData.width && productData.width !== 'N/A' ? `<p><strong>${labelWidth}</strong> ${productData.width}</p>` : ''}
        ${productData.length && productData.length !== 'N/A' ? `<p><strong>${labelLength}</strong> ${productData.length}</p>` : ''}
      </div>
      <div class="product-sidebar__technical-file">
        ${
        productData.technicalFile && productData.technicalFile !== 'N/A'
          ? `<a href="${productData.technicalFile}" class="button__ghost" download target="_blank" rel="noopener noreferrer">Télécharger la fiche technique</a>`
          : ''
        }
      </div>
      </div>
    `;
    
    // Ajouter le contenu rich text séparément pour qu'il soit interprété comme HTML
    const descriptionElement = this.sidebar.querySelector('.product-sidebar__description');
    if (descriptionElement && productData.longdescription && productData.longdescription !== 'N/A') {
      descriptionElement.innerHTML = productData.longdescription;
    }
    
    // Re-bind les événements de fermeture après mise à jour du contenu
    this.bindCloseEvents();
  }

  getProductMetafields() {
    // Essayer de récupérer les données depuis les éléments de la page
    const productData = {
      bigProductCard: 'N/A',
      longdescription: 'N/A',
      limited: 'N/A',
      unique: 'N/A',
      year: 'N/A',
      diameter: 'N/A',
      height: 'N/A',
      technicalFile: 'N/A',
      width: 'N/A',
      length: 'N/A',
    };

    try {
      // Récupérer depuis notre script spécifique
      const productScript = document.querySelector('#product-metafields-data');
      if (productScript) {
        console.log('Script métafields trouvé');
        const product = JSON.parse(productScript.textContent);
        console.log('Données produit:', product);
        
        if (product.metafields) {
          productData.bigProductCard = product.metafields.bigProductCard || 'N/A';
          productData.longdescription = product.metafields.longdescription || 'N/A';
          productData.diameter = product.metafields.diameter || 'N/A';
          productData.height = product.metafields.height || 'N/A';
          productData.technicalFile = product.metafields.technicalFile || 'N/A';
          productData.width = product.metafields.width || 'N/A';
          productData.length = product.metafields.length || 'N/A';
        }
      } else {
        console.log('Script métafields non trouvé');
      }
    } catch (error) {
      console.log('Erreur lors du chargement des métafields:', error);
    }

    console.log('Données finales:', productData);
    return productData;
  }

  loadDeliveryContent() {
    if (!this.sidebar) return;
    
    const deliveryTemplate = document.querySelector('#delivery-info-content');
    const deliveryHtml = deliveryTemplate ? deliveryTemplate.innerHTML.trim() : '';
    // Récupère la traduction depuis l'attribut data- du template
    const deliveryTitle = document.documentElement.getAttribute('data-delivery-title') || 'Delivery';
    const whatsappButton = document.documentElement.getAttribute('data-whatsapp-button') || 'Chat with us on WhatsApp';
    this.sidebar.innerHTML = `
      <div class="product-sidebar__header">
      <h3>${deliveryTitle}</h3>
      <button class="product-sidebar__close" aria-label="Fermer">
      <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.575736 4.57574C0.341421 4.81005 0.341421 5.18995 0.575736 5.42426L4.39411 9.24264C4.62843 9.47696 5.00833 9.47696 5.24264 9.24264C5.47696 9.00833 5.47696 8.62843 5.24264 8.39411L1.84853 5L5.24264 1.60589C5.47696 1.37157 5.47696 0.991674 5.24264 0.757359C5.00833 0.523045 4.62843 0.523045 4.39411 0.757359L0.575736 4.57574ZM19 5V4.4L1 4.4V5V5.6L19 5.6V5Z" fill="#0A0A0A"/>
      </svg>
      </button>
      </div>
      <div class="product-sidebar__content">
      <div class="product-sidebar__description">
      ${deliveryHtml}
      </div>
      <a href="https://wa.me/+33625180477" class="button__ghost" target="_blank" rel="noopener noreferrer">${whatsappButton}</a>
      </div>
    `;
    
    // Re-bind les événements de fermeture après mise à jour du contenu
    this.bindCloseEvents();
  }

  bindCloseEvents() {
    // Événement pour fermer la sidebar
    if (this.sidebar) {
      const closeButton = this.sidebar.querySelector('.product-sidebar__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.close();
        });
      }
    }
  }

  bindEvents() {
    console.log('ProductSidebar: Événements liés');
    
    // Événement pour ouvrir la sidebar
    document.addEventListener('click', (e) => {
      const target = e.target;
      if (!target || !(target instanceof Element)) return;
      
      console.log('Clic détecté sur:', target, 'Texte:', target.textContent);
      
      // Chercher le bouton "En savoir plus" spécifiquement
      const button = target.closest('a, button');
      if (button) {
        console.log('Bouton trouvé:', button, 'Texte:', button.textContent, 'Href:', button.getAttribute('href'));
        
        // Ignorer les boutons qui ont la classe professional-sidebar-trigger
        if (button.classList.contains('professional-sidebar-trigger')) {
          return;
        }
        
        // Détecter par classe CSS d'abord
        if (button.classList.contains('product-detail-trigger')) {
          console.log('Bouton "détail du produit" détecté par classe - ouverture sidebar');
          e.preventDefault();
          this.loadProductData();
          this.open();
          return;
        }
        
        if (button.classList.contains('services-delivery-trigger')) {
          console.log('Bouton "livraison" détecté par classe - ouverture sidebar');
          e.preventDefault();
          this.loadDeliveryContent();
          this.open();
          return;
        }
        
        // Fallback: détecter par texte pour les boutons du template JSON
        const buttonText = button.textContent ? button.textContent.trim().toLowerCase() : '';
        
        if (buttonText.includes('détails de l\'œuvre') || buttonText.includes('details of the piece') || buttonText.includes('détail')) {
          console.log('Bouton "détail du produit" détecté par texte - ouverture sidebar');
          e.preventDefault();
          this.loadProductData();
          this.open();
        } else if (buttonText.includes('services & expédition') || buttonText.includes('services & delivery') || buttonText.includes('delivery') || buttonText.includes('expédition')) {
          console.log('Bouton "livraison" détecté par texte - ouverture sidebar');
          e.preventDefault();
          this.loadDeliveryContent();
          this.open();
        }
      }
    });

    // Fermer en cliquant sur l'overlay
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.close();
      });
    }

    // Fermer avec la touche Échap
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  open() {
    console.log('ProductSidebar: Tentative d\'ouverture');
    if (this.sidebar && this.overlay) {
      console.log('ProductSidebar: Ouverture de la sidebar');
      this.overlay.classList.add('active');
      this.sidebar.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      console.log('ProductSidebar: Erreur - sidebar ou overlay non trouvé');
    }
  }

  close() {
    console.log('ProductSidebar: Fermeture de la sidebar');
    if (this.sidebar && this.overlay) {
      this.overlay.classList.remove('active');
      this.sidebar.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  isOpen() {
    return this.sidebar && this.sidebar.classList.contains('active');
  }
}

// Initialiser quand le DOM est prêt
/**
 * @type {Window & typeof globalThis & { productSidebarInstance?: ProductSidebar }}
 */
const globalWindow = window;

document.addEventListener('DOMContentLoaded', () => {
  globalWindow.productSidebarInstance = new ProductSidebar();
});